var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask type2" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size sm3_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close_type2",
            attrs: { href: "javascript:", type: "button" },
            on: { click: _vm.goListBack }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("div", { staticClass: "container register" }, [
            _c("div", { staticClass: "title" }, [
              _c("h1", [_vm._v(_vm._s(_vm.data.msg1))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
              _c("div", { staticClass: "one-register" }, [
                _c("dl", { staticClass: "register_end_txt" }, [
                  _c("dt", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.data.msg3) +
                        "\n                                    " +
                        _vm._s(_vm.data.msg4) +
                        "\n                                    " +
                        _vm._s(_vm.data.msg5) +
                        "\n                                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("div", [
                      _vm._v("[" + _vm._s(_vm.$t("FIELD.EUR.NOTE")) + "]")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      _vm._v(
                        "1. " + _vm._s(_vm.$t("MESSAGE.EUR.USER.RULES.ONE"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.data.show,
                            expression: "data.show"
                          }
                        ],
                        staticStyle: { "text-align": "left" }
                      },
                      [
                        _vm._v(
                          "2. " +
                            _vm._s(
                              _vm.$t("MESSAGE.EUR.USER.RULES.TWO", [
                                _vm.data.mon
                              ])
                            )
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f01cd05e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f01cd05e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/RequestSuccPopup.vue
// module id = Cwrb
// module chunks = 0